import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil'
import { lowerLanguage } from 'src/i18n'
import { selectorFooterDocuments } from 'src/storage'
import { Document } from 'src/types'

export const useAccessibility = () => {
  const { t } = useTranslation()
  const documents = useRecoilValue(selectorFooterDocuments)
  const accessibilityWebDoc = documents?.find(({ docCode }) => docCode === 'FOOTER_RC_3')

  const openDocumentInNewTab = (document: Document | undefined) => {
    if (document) {
      const base64 = document.filePath[lowerLanguage]
      const byteCharacters = atob(base64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      window.open(url, '_blank')
    }
  }

  return {
    t,
    openAccessibilityWebDoc: () => openDocumentInNewTab(accessibilityWebDoc),
  }
}
